export const coinManagementConstant = {
   //get
   GET_COIN_LIST_REQUEST: "GET_COIN_USER_LIST_REQUEST",
   GET_COIN_LIST_SUCCESS: "GET_COIN_USER_LIST_SUCCESS",
   GET_COIN_LIST_FAILURE: "GET_COIN_USER_LIST_FAILURE",



   GET_ALL_FIAT_CURRENCY_LIST_REQUEST: "GET_ALL_FIAT_CURRENCY_USER_LIST_REQUEST",
   GET_ALL_FIAT_CURRENCY_LIST_SUCCESS: "GET_ALL_FIAT_CURRENCY_USER_LIST_SUCCESS",
   GET_ALL_FIAT_CURRENCY_LIST_FAILURE: "GET_ALL_FIAT_CURRENCY_USER_LIST_FAILURE",

   //add
   CREATE_COIN_LIST_REQUEST: "CREATE_COIN_LIST_REQUEST",
   CREATE_COIN_LIST_SUCCESS: "CREATE_COIN_LIST_SUCCESS",
   CREATE_COIN_LIST_FAILURE: "CREATE_COIN_LIST_FAILURE",
   //update
   UPDATE_COIN_REQUEST: "UPDATE_COIN_REQUEST",
   UPDATE_COIN_SUCCESS: "UPDATE_COIN_SUCCESS",
   UPDATE_COIN_FAILURE: "UPDATE_COIN_FAILURE",
   //update
   UPDATE_COIN_STATUS_REQUEST: "UPDATE_COIN_STATUS_REQUEST",
   UPDATE_COIN_STATUS_SUCCESS: "UPDATE_COIN_STATUS_SUCCESS",
   UPDATE_COIN_STATUS_FAILURE: "UPDATE_COIN_STATUS_FAILURE",
   //delete
   DELETE_COIN_REQUEST: "DELETE_COIN_REQUEST",
   DELETE_COIN_SUCCESS: "DELETE_COIN_SUCCESS",
   DELETE_COIN_FAILURE: "DELETE_COIN_FAILURE",


   //add
   CREATE_APIKEY_REQUEST: "CREATE_APIKEY_LIST_REQUEST",
   CREATE_APIKEY_SUCCESS: "CREATE_APIKEY_LIST_SUCCESS",
   CREATE_APIKEY_FAILURE: "CREATE_APIKEY_LIST_FAILURE",


   GET_HISTORY_LIST_REQUEST: "GET_HISTORY_LIST_REQUEST",
   GET_HISTORY_LIST_SUCCESS: "GET_HISTORY_LIST_SUCCESS",
   GET_HISTORY_LIST_FAILURE: "GET_HISTORY_LIST_FAILURE",

   GET_PKRD_HISTORY_LIST_REQUEST: "GET_PKRD_HISTORY_LIST_REQUEST",
   GET_PKRD_HISTORY_LIST_SUCCESS: "GET_PKRD_HISTORY_LIST_SUCCESS",
   GET_PKRD_HISTORY_LIST_FAILURE: "GET_PKRD_HISTORY_LIST_FAILURE",
};
